import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fleet-package-modal',
  templateUrl: './fleet-package-modal.component.html',
  styleUrls: ['./fleet-package-modal.component.scss'],
})
export class FleetPackageModalComponent {
  constructor(private dialogRef: MatDialogRef<FleetPackageModalComponent>) {}
  close() {
    this.dialogRef.close();
  }
}
